/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Openquestionscancel2Inputs */

const en_openquestionscancel2 = /** @type {(inputs: Openquestionscancel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const pt_openquestionscancel2 = /** @type {(inputs: Openquestionscancel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Openquestionscancel2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const openquestionscancel2 = /** @type {((inputs?: Openquestionscancel2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Openquestionscancel2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_openquestionscancel2(inputs)
	return pt_openquestionscancel2(inputs)
});
export { openquestionscancel2 as "openQuestionsCancel" }